/**
 * Copyright (c) 2016-2020 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    Ahmet Dogramaci
 * Date      2020-03-21
 */
import WatchExpression from "../enums/watch-expression";

class ConfigurationTemplateDecisionTrigger {
    constructor() {
        this.watch_expression = WatchExpression.IS_SELECTED;
        this.node_object = null;
        this.decision_object = null;
    }

    buildFromJson(json_object){
        this.id = json_object.id;
        this.watch_expression = json_object.watch_expression;
        this.node = this.decision.template_version.getNodeById(json_object.cfg_template_node_id);
        this.node.addDecisionTrigger(this);
    }

    set node(node_in){
        this.node_object = node_in;
    }

    get node(){
        return this.node_object;
    }

    get decision(){
        return this.decision_object;
    }

    set decision(value){
        this.decision_object = value;
    }

    get isSelectedExpression(){
        return this.watch_expression === WatchExpression.IS_SELECTED;
    }

    get isUnselectedExpression(){
        return this.watch_expression === WatchExpression.IS_UNSELECTED;
    }

    get isSatisfied(){
        if(this.node_object.isSelected && this.isSelectedExpression){
            return true
        }
        if(this.node_object.isUnselected && this.isUnselectedExpression){
            return true
        }
        return false;
    }

    evaluateDecision(){
        console.log(`Decision:${this.decision.name}, trigger for Node:${this.node.code} is evaluating`);
        if(this.isSatisfied && this.decision.watchesStatus){
            this.decision.performActions(true);
        }
        if(!this.isSatisfied && this.decision.watchesStatus){
            this.decision.performActions(false);
        }
    }
}
export default ConfigurationTemplateDecisionTrigger;